"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _mobxReact = require("mobx-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _includes = _interopRequireDefault(require("lodash/includes"));
var _filter = _interopRequireDefault(require("lodash/filter"));
var _first = _interopRequireDefault(require("lodash/first"));
var _enums = require("../../enums");
var _Button = require("../Button");
var _FormattedComponents = require("../FormattedComponents");
var _Icon = _interopRequireDefault(require("../Icon"));
var _messages = _interopRequireDefault(require("./messages"));
var _styles = require("./styles");
var _posthogUtils = require("../../utils/posthog-utils");
var _posthogEvents = require("../../posthog-events");
var _EmailAndPasswordLogin = _interopRequireDefault(require("../EmailAndPasswordLogin"));
var _kebabCase = _interopRequireDefault(require("lodash/kebabCase"));
var _excluded = ["store", "views"];
var _dec, _class, _SignInOptionsPickerComponent; //enums
//components
//messages
//styles
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SignInOptionsPickerComponent = (_dec = (0, _mobxReact.inject)('store'), (0, _reactIntl.injectIntl)(_class = _dec(_class = (0, _mobxReact.observer)(_class = (_SignInOptionsPickerComponent = /*#__PURE__*/function (_Component) {
  function SignInOptionsPickerComponent() {
    _classCallCheck(this, SignInOptionsPickerComponent);
    return _callSuper(this, SignInOptionsPickerComponent, arguments);
  }
  _inherits(SignInOptionsPickerComponent, _Component);
  return _createClass(SignInOptionsPickerComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var store = this.props.store;
      store.platform.fetchPlatformFlags();
    }
  }, {
    key: "buildSsoUrl",
    value: function buildSsoUrl(href) {
      var ssoUrl = new URL("".concat(window.location.origin, "/sso/login"));
      ssoUrl.searchParams.append('href', href);
      ssoUrl.searchParams.append('origin', 'viewer');
      return ssoUrl;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        intl = _this$props.intl,
        store = _this$props.store,
        device = _this$props.device,
        views = _this$props.views,
        redirect = _this$props.redirect,
        preserveRedirect = _this$props.preserveRedirect;
      var formatMessage = intl.formatMessage;
      var platform = store.platform;
      var sso = platform.sso,
        loginOptions = platform.domain.loginOptions,
        isContentProtected = platform.isContentProtected,
        contactMethodSelection = platform.developmentFeatureFlags.contactMethodSelection;
      var ssoUrl = this.buildSsoUrl(redirect);
      var style = {
        letterSpacing: '0',
        fontWeight: '400'
      };
      var redirectParams = preserveRedirect ? {
        queryParams: {
          redirect: redirect
        }
      } : {};
      var SignInOptionsConfig = (0, _filter["default"])([{
        id: _enums.DOMAIN_LOGIN_OPTIONS.SSO,
        label: formatMessage(_messages["default"].ssoLogin),
        shouldShow: Boolean(sso),
        iconName: sso,
        posthogEvent: _posthogEvents.posthogEvents.selectSsoSignIn,
        urlProps: {
          href: ssoUrl.href
        }
      }, {
        id: _enums.DOMAIN_LOGIN_OPTIONS.EMAIL,
        label: formatMessage(_messages["default"].emailAndPasswordLogin),
        shouldShow: (0, _includes["default"])(loginOptions, _enums.DOMAIN_LOGIN_OPTIONS.EMAIL),
        iconName: 'email-outline',
        posthogEvent: _posthogEvents.posthogEvents.selectEmailSignIn,
        urlProps: {
          store: store,
          route: views.signIn,
          params: {
            loginType: _enums.DOMAIN_LOGIN_OPTIONS.EMAIL.toLowerCase()
          }
        }
      }, {
        id: _enums.DOMAIN_LOGIN_OPTIONS.PHONE_NUMBER,
        label: formatMessage(_messages["default"].phoneNumber),
        shouldShow: (0, _includes["default"])(loginOptions, _enums.DOMAIN_LOGIN_OPTIONS.EMAIL) && contactMethodSelection,
        iconName: 'phone',
        urlProps: {
          store: store,
          route: views.signIn,
          params: {
            loginType: (0, _kebabCase["default"])(_enums.DOMAIN_LOGIN_OPTIONS.PHONE_NUMBER.toLowerCase())
          }
        }
      }, {
        id: _enums.DOMAIN_LOGIN_OPTIONS.DOMAIN_PASSWORD,
        shouldShow: (0, _includes["default"])(loginOptions, _enums.DOMAIN_LOGIN_OPTIONS.DOMAIN_PASSWORD),
        label: formatMessage(_messages["default"].domainPasswordLogin),
        iconName: 'workspace',
        posthogEvent: _posthogEvents.posthogEvents.selectWorkspacePasswordSignIn,
        urlProps: {
          store: store,
          route: views.signIn,
          params: {
            loginType: _enums.DOMAIN_LOGIN_OPTIONS.DOMAIN_PASSWORD.toLowerCase()
          }
        }
      }], 'shouldShow');
      var StyledSignInOptionButton = device === 'desktop' ? _styles.StyledSignInOptionButtonDesktop : _styles.StyledSignInOptionButtonMobile;
      var shouldRenderOptionDirectly = SignInOptionsConfig.length === 1 && (0, _first["default"])(SignInOptionsConfig).id !== _enums.DOMAIN_LOGIN_OPTIONS.SSO;
      var CurrentComponent = shouldRenderOptionDirectly ? /*#__PURE__*/_react["default"].createElement(_EmailAndPasswordLogin["default"], {
        loginOption: (0, _first["default"])(SignInOptionsConfig).id
      }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, SignInOptionsConfig.map(function (signInOption) {
        return /*#__PURE__*/_react["default"].createElement(StyledSignInOptionButton, _extends({
          key: signInOption.id,
          "data-testid": "sign-in-option-".concat(signInOption.id),
          iconName: signInOption.iconName,
          iconComponent: _Icon["default"],
          onClick: (0, _posthogUtils.posthogCapture)(signInOption.posthogEvent)
        }, redirectParams, signInOption.urlProps), signInOption.label);
      }));
      return isContentProtected ? /*#__PURE__*/_react["default"].createElement(_styles.PickerContainer, {
        "data-testid": "picker-container"
      }, CurrentComponent, /*#__PURE__*/_react["default"].createElement(_Button.ButtonGroup, {
        direction: "column"
      }, contactMethodSelection && /*#__PURE__*/_react["default"].createElement(_styles.StyledButton, {
        style: style,
        "data-testid": "activation-code",
        href: "/activation-code"
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].formAction_iHaveAnActivationCode)), /*#__PURE__*/_react["default"].createElement(_styles.StyledButton, {
        style: style,
        "data-testid": "admin-account",
        href: "/admin/login?redirect=".concat(window.location.href)
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].formAction_iHaveAnAdminAccount)))) : null;
    }
  }]);
}(_react.Component), _defineProperty(_SignInOptionsPickerComponent, "propTypes", {
  device: _propTypes["default"].oneOf(['desktop', 'mobile']).isRequired,
  views: _propTypes["default"].object.isRequired,
  /**
   * The url to redirect to after signing in
   */
  redirect: _propTypes["default"].string,
  /**
   * If true, the redirect will be passed as a query param when navigating to the sign in page
   */
  preserveRedirect: _propTypes["default"].bool
}), _SignInOptionsPickerComponent)) || _class) || _class) || _class);
/**
 * A wrapper around the SignInOptionsPickerComponent that is aware of how it
 * should handle redirections depending on the current route.
 */
var RouteAwareSignInOptionsPicker = (0, _mobxReact.inject)('store')((0, _mobxReact.observer)(function (_ref) {
  var _queryParams$redirect;
  var store = _ref.store,
    views = _ref.views,
    props = _objectWithoutProperties(_ref, _excluded);
  var _store$router = store.router,
    currentRoute = _store$router.currentRoute,
    queryParams = _store$router.queryParams;
  var currentLocation = window.location.href;
  var redirectQueryParam = queryParams === null || queryParams === void 0 ? void 0 : queryParams.redirect;
  var isOnDomainLoginView = currentRoute === views.domainLogin;
  var preserveRedirect = !isOnDomainLoginView || redirectQueryParam;
  var fallbackRedirect = !isOnDomainLoginView ? currentLocation : "".concat(window.location.origin).concat(views.explorer.path);
  var redirect = (_queryParams$redirect = queryParams === null || queryParams === void 0 ? void 0 : queryParams.redirect) !== null && _queryParams$redirect !== void 0 ? _queryParams$redirect : fallbackRedirect;
  return /*#__PURE__*/_react["default"].createElement(SignInOptionsPickerComponent, _extends({
    preserveRedirect: preserveRedirect,
    redirect: redirect,
    views: views
  }, props));
}));
var _default = exports["default"] = RouteAwareSignInOptionsPicker;
//# sourceMappingURL=index.js.map